import PropTypes from 'prop-types';

export const Icons = ({ testid, className, variant, color }) => {
  const renderIcon = () => {
    switch (variant) {
      case Icons.Transaction: {
        return (
          <svg
            width="36"
            height="36"
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle opacity="1" cx="18" cy="18" r="18" fill={color} />
            <path
              d="M11.1938 13.1401H24.805M24.805 13.1401L21.4022 9.7373M24.805 13.1401L21.4022 16.5429"
              stroke={'#fff'}
              strokeWidth="3"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M24.8047 22.8608H11.1936M11.1936 22.8608L14.5964 19.458M11.1936 22.8608L14.5964 26.2636"
              stroke={'#fff'}
              strokeWidth="3"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      }

      case Icons.Project: {
        return (
          <svg
            width="36"
            height="36"
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="18" cy="18" r="18" fill={color} />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M23.7778 8.76983C24.6956 8.76983 25.5746 9.13636 26.2217 9.78674C26.8685 10.4369 27.2308 11.3174 27.2308 12.2342V24.9975C27.2308 25.9143 26.8685 26.7948 26.2217 27.445C25.5746 28.0954 24.6957 28.4619 23.7779 28.4619L12.2223 28.4621C11.3045 28.4621 10.4255 28.0956 9.77843 27.4452C9.13157 26.7951 8.76929 25.9146 8.76929 24.9978V12.2344C8.76929 11.3177 9.13157 10.4372 9.77843 9.78699C10.4255 9.13661 11.3045 8.77008 12.2223 8.77008L23.7778 8.76983ZM23.7778 11.2314L12.2223 11.2316C11.9614 11.2316 11.7099 11.3357 11.5234 11.5231C11.3368 11.7107 11.2308 11.9665 11.2308 12.2344V24.9978C11.2308 25.2658 11.3368 25.5215 11.5234 25.7091C11.7098 25.8965 11.9613 26.0006 12.2223 26.0006L23.7778 26.0003C24.0387 26.0003 24.2903 25.8962 24.4767 25.7089C24.6633 25.5213 24.7693 25.2655 24.7693 24.9975V12.2342C24.7693 11.9662 24.6633 11.7105 24.4767 11.5229C24.2903 11.3355 24.0387 11.2314 23.7778 11.2314Z"
              fill="white"
            />
            <path
              d="M13.6924 10.1544C13.6924 8.59808 15.0912 7.53906 16.5495 7.53906H19.4506C20.9089 7.53906 22.3077 8.59808 22.3077 10.1544C22.3077 11.7108 20.9089 12.7698 19.4506 12.7698H16.5495C15.0912 12.7698 13.6924 11.7108 13.6924 10.1544Z"
              fill="white"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M13.9487 16.8732C13.9487 16.1935 14.4997 15.6424 15.1794 15.6424H20.8205C21.5002 15.6424 22.0512 16.1935 22.0512 16.8732C22.0512 17.5529 21.5002 18.104 20.8205 18.104H15.1794C14.4997 18.104 13.9487 17.5529 13.9487 16.8732Z"
              fill="white"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M13.9487 21.3852C13.9487 20.7055 14.4997 20.1544 15.1794 20.1544H20.8205C21.5002 20.1544 22.0512 20.7055 22.0512 21.3852C22.0512 22.065 21.5002 22.616 20.8205 22.616H15.1794C14.4997 22.616 13.9487 22.065 13.9487 21.3852Z"
              fill="white"
            />
          </svg>
        );
      }

      case Icons.Milestones: {
        return (
          <svg
            width="36"
            height="36"
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="18" cy="18" r="18" fill="#928CDA" />
            <g clipPath="url(#clip0_76800_129372)">
              <path
                d="M17.167 13H24.667"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M17.167 18H24.667"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M17.167 23H24.667"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <circle cx="12.5833" cy="13.0013" r="1.08333" stroke="white" strokeWidth="2" />
              <circle cx="12.5833" cy="18.0013" r="1.08333" stroke="white" strokeWidth="2" />
              <circle cx="12.5833" cy="23.0013" r="1.08333" stroke="white" strokeWidth="2" />
            </g>
            <defs>
              <clipPath id="clip0_76800_129372">
                <rect width="20" height="20" fill="white" transform="translate(8 8)" />
              </clipPath>
            </defs>
          </svg>
        );
      }

      case Icons.Calendar: {
        return (
          <svg
            width="36"
            height="36"
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="18" cy="18" r="18" fill={color || '#04A451'} />
            <path
              d="M22.8605 11.5234H13.1405C12.2458 11.5234 11.5205 12.2487 11.5205 13.1434V22.8634C11.5205 23.7581 12.2458 24.4834 13.1405 24.4834H22.8605C23.7552 24.4834 24.4805 23.7581 24.4805 22.8634V13.1434C24.4805 12.2487 23.7552 11.5234 22.8605 11.5234Z"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M21.2402 10.4375V12.5975"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M14.7598 10.4375V12.5975"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M11.5205 15.8359H24.4805"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      }

      default:
        return null;
    }
  };

  return (
    <div testid={testid} className={className}>
      {renderIcon()}
    </div>
  );
};

Icons.Transaction = 'transaction';
Icons.Project = 'project';
Icons.Milestones = 'milestone';
Icons.Calendar = 'calendar';

Icons.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  testid: PropTypes.string,
  variant: PropTypes.string,
};

Icons.defaultProps = {
  className: '',
  color: '',
  testid: undefined,
  variant: '',
};
